import { useEffect, useRef } from 'react';
import axios from 'axios';
import { ArrowRight, Megaphone } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function LocalAdCreative({ ad, variant = 'responsive', className = '' }) {
  const impressionSent = useRef(false);
  const horizontal = ad?.image_horizontal_url || ad?.image_url || '';
  const vertical = ad?.image_vertical_url || horizontal;
  const compact = variant === 'banner';
  const sidebar = variant === 'sidebar';
  const creativeFrame = sidebar
    ? 'aspect-[4/5]'
    : 'aspect-[4/5] sm:aspect-[8/3]';

  useEffect(() => {
    if (!ad?.id || ad.is_house_ad || impressionSent.current) return;
    impressionSent.current = true;
    axios.post(`${API}/api/ads/${ad.id}/impression`).catch(() => {});
  }, [ad?.id, ad?.is_house_ad]);

  if (!ad) return null;

  const recordClick = () => {
    if (!ad.is_house_ad && ad.id) {
      axios.post(`${API}/api/ads/${ad.id}/click`).catch(() => {});
    }
  };

  return (
    <aside
      className={`${compact ? 'my-6' : sidebar ? '' : 'my-8'} overflow-hidden rounded-sm border border-rastyle-orange/25 bg-zinc-950 ${className}`}
      aria-label="Sponsored content"
      data-testid="responsive-local-ad"
      data-ad-source="local"
    >
      <a href={ad.link || '#'} onClick={recordClick} className={`group block ${compact ? 'sm:grid sm:grid-cols-[minmax(12rem,0.7fr)_1fr]' : ''}`}>
        {horizontal ? (
          <picture
            className={`relative block w-full overflow-hidden bg-black ${creativeFrame}`}
            data-testid="local-ad-creative-frame"
            data-creative-fit="contain"
          >
            <source media="(max-width: 639px)" srcSet={vertical} />
            <img
              src={horizontal}
              alt={ad.title || 'Sponsored'}
              className="absolute inset-0 h-full w-full object-contain"
            />
          </picture>
        ) : (
          <div className={`${compact ? 'min-h-28 sm:min-h-40' : 'min-h-40'} flex items-center justify-center bg-gradient-to-br from-rastyle-orange/20 to-green-600/10`}>
            <Megaphone className="h-10 w-10 text-rastyle-orange" />
          </div>
        )}
        <div className={`${compact ? 'p-4' : 'p-5'} flex flex-col gap-3 sm:justify-center`}>
          <div>
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-rastyle-orange">Sponsored</span>
            <h2 className={`${compact || sidebar ? 'text-lg' : 'text-xl'} mt-1 font-heading font-black text-white`}>{ad.title}</h2>
            {ad.subtitle && <p className="mt-1 text-sm text-zinc-400">{ad.subtitle}</p>}
          </div>
          <span className="inline-flex items-center gap-2 font-bold text-rastyle-orange">
            {ad.cta || 'Learn More'} <ArrowRight className="h-4 w-4 transition group-hover:translate-x-1" />
          </span>
        </div>
      </a>
    </aside>
  );
}
